// extracted by mini-css-extract-plugin
export default {"langItem":"mCeFa","selected":"Mq4_p","image":"lN9nP","title":"dCmyq"};